export function drawer() {
  const drawers = document.querySelectorAll('.js-drawer');
  if(drawers.length){
    drawers.forEach((el, index) => {
      const trigger = el.querySelector('.js-trigger-drawer');
      if(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          if(el.classList.contains('is-active')) {
            el.classList.remove('is-active')
          } else {
            el.classList.add('is-active')
          }
        });
      }
    });
  }
}